import {
  makeStyles,
  withStyles,
  Switch as StyledSwitch,
} from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  row: {
    '&:nth-child(odd)': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  action: {
    color: theme.palette.action.main,
  },
}));

export const Switch = withStyles(theme => ({
  switchBase: {
    color: theme.palette.secondary.dark,
    '&$checked': {
      color: theme.palette.action.main,
    },
    '&$checked + $track': {
      backgroundColor: theme.palette.action.light,
    },
    '&$disabled': {
      color: theme.palette.secondary.main,
    },
  },
  checked: {},
  track: {},
  disabled: {},
}))(StyledSwitch);
